var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9286 0H1.07143C0.479695 0 -2.37202e-07 0.482155 0 1.07692V9.69231C0 10.2871 0.479695 10.7692 1.07143 10.7692H5.35714V12.9231H3.21429V14H11.7857V12.9231H9.64286V10.7692H13.9286C14.5203 10.7692 15 10.2871 15 9.69231V1.07692C15 0.482155 14.5203 0 13.9286 0ZM8.57143 12.9231H6.42857V10.7692H8.57143V12.9231ZM13.9286 9.69231H1.07143V1.07692H13.9286V9.69231Z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/DesktopIcon.ffce9a861b5357b1d6ec7d184bc20fad.svg";
export { ForwardRef as ReactComponent };